import React from "react";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";
import TournamentRating from "./TournamentRating";
import { openTournamentRating } from "../../../utils/tournamentRatingBus";

// Top-level "Results" tab (Tournament.js) - this tournament's own place/
// score/stats results (TournamentRating below). Used to also offer the
// full/overall rating standings (RatingTable) as a second "Overall rating"
// sub-tab here, picked with the same stage-tabs-scroll bar TournamentPlayers.
// js uses for its own List/Результати switch - dropped in favor of the same
// icon-button-into-a-modal TournamentPlayers.js already uses for this
// (openTournamentRating, Header.js's always-mounted rating modal) instead of
// a second full tab switch for what both views already agree is the same
// data. Only "List" is left in the bar now, kept (not collapsed away) so it
// still matches the same stage-tabs-wrap look every other tab uses.
const TournamentRatingTab = ({ tournament, is_authorized, searchChips }) => {
    const { t } = useTranslation();

    return (
        <>
            <ul className="tabs" style={{ marginTop: "10px", marginBottom: "10px" }}>
                <li className="stage-tabs-wrap">
                    <ul className="stage-tabs-scroll">
                        <li className="active">
                            <a href="#" onClick={(e) => e.preventDefault()}>{t("List")}</a>
                        </li>
                    </ul>
                </li>
                {tournament?.rating && (
                    <li className="right">
                        <a href="#" className="action-button matches-btn" onClick={(e) => { e.preventDefault(); openTournamentRating(); }}>
                            <FeatherIcon icon="bar-chart-2" />
                            <span className="btn-label">{t("Rating")}</span>
                        </a>
                    </li>
                )}
            </ul>

            {/* Forced to "list" (no grid toggle here) - this view's only job
                on this tab is to read like RatingTable's own rows, not to
                duplicate Участники's full grid/list picker. */}
            <TournamentRating
                tournament={tournament}
                is_authorized={is_authorized}
                viewMode="list"
                searchChips={searchChips}
            />
        </>
    );
};

export default TournamentRatingTab;
